import { WHO_WE_ARE, IMAGES } from "../mock";
import { Landmark, Cpu, Flame } from "lucide-react";

const ICONS = [Landmark, Cpu, Flame];

export default function WhoWeAre() {
  return (
    <section className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div className="reveal">
            <span className="text-xs font-semibold tracking-[0.22em] text-teal-300 uppercase">
              {WHO_WE_ARE.eyebrow}
            </span>
            <h2 className="font-display font-bold text-white text-3xl lg:text-4xl mt-4 leading-tight tracking-tight">
              {WHO_WE_ARE.title}
            </h2>
            <p className="mt-6 text-slate-300/85 leading-relaxed">{WHO_WE_ARE.body}</p>

            <div className="mt-10 space-y-3">
              {WHO_WE_ARE.pillars.map((p, i) => {
                const Icon = ICONS[i];
                return (
                  <div
                    key={i}
                    className="group flex items-start gap-4 rounded-xl border border-teal-500/10 bg-white/[0.02] p-4 transition-all hover:border-teal-400/30 hover:bg-white/[0.04]"
                  >
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-teal-500/10 text-teal-300 transition-colors group-hover:bg-teal-500/20">
                      <Icon size={20} />
                    </span>
                    <div>
                      <h4 className="font-display font-semibold text-white">{p.title}</h4>
                      <p className="text-sm text-slate-400 mt-0.5">{p.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="reveal relative">
            <div className="relative rounded-2xl overflow-hidden border border-teal-500/15 glow-teal">
              <img
                src={IMAGES.strategyMeeting}
                alt="Corporate strategy session"
                className="w-full h-[440px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#04100f] via-[#04100f]/20 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="rounded-xl bg-[#04100f]/70 backdrop-blur-md border border-teal-500/15 p-5">
                  <p className="text-sm text-slate-300">
                    <span className="font-display font-semibold text-white">Founded in Muscat</span> {"\u2014"} partnering with leaders across the GCC region.
                  </p>
                </div>
              </div>
            </div>
            <div className="absolute -top-6 -right-6 h-24 w-24 rounded-2xl border border-teal-500/20 bg-teal-500/5 backdrop-blur animate-float-slow hidden md:block" />
          </div>
        </div>
      </div>
    </section>
  );
}